import React from 'react'
import { CaptionSM, TitleXS } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { BaseTooltip, BaseTooltipProps } from '.'

export const TLRToolTip: React.FC<BaseTooltipProps> = ({
  className,
  buttonClassName,
  panelClassName,
  panelPosition = 'CENTER',
  isIconOnly,
  buttonStyle,
  titleText,
  children,
}) => {
  const { t } = useTranslate('tickets')

  const trigger = (
    <>
      {!isIconOnly && children ? (
        children
      ) : (
        <span
          className={`!border-none text-white underline !outline-none !ring-0 !ring-transparent ${
            buttonClassName || ''
          }`}
        >
          {titleText ? titleText : t('tlrToolTipCTA', 'Valid matinee show times through Sunday, May 26')}
        </span>
      )}
    </>
  )

  const content = (
    <>
      <TitleXS color="core-gray-950" weight="bold">
        {t('specificShowTimesDetails', 'Specific Showtimes Details')}
      </TitleXS>
      <div className="mt-2 flex flex-col gap-1 text-[0.688rem] leading-[16px] !ring-0 !ring-transparent">
        <CaptionSM color="core-gray-700">
          {t('monWedThurs', 'Mon, Wed & Thurs')} <span className="uppercase">({t('allDay', 'All Day')})</span>
        </CaptionSM>
        <CaptionSM color="core-gray-700">{t('friBefore5AndAfter9', 'Fri (Before 5pm & After 9pm)')}</CaptionSM>
        <CaptionSM color="core-gray-700">{t('satToSunAfter9tooltip', 'Sat–Sun (After 9pm)')}</CaptionSM>
      </div>
    </>
  )

  return (
    <BaseTooltip
      className={className}
      buttonClassName={buttonClassName}
      panelClassName={panelClassName}
      panelPosition={panelPosition}
      isIconOnly={isIconOnly}
      removeBorder={true}
      buttonStyle={buttonStyle}
      trigger={trigger}
      content={content}
    />
  )
}
